import { Box, Button, Stack } from "@mui/material";
import { COLORS } from "assets";
import { DetailField, MyModal } from "components";
import useTranslation from "hooks/useTranslation";
import { APITokenModel } from "types";
import { dateFormat } from "utils";
import TokenShow from "./token";

interface IView {
  onClose: () => void;
  token: APITokenModel;
}

export default function View({ onClose, token }: IView) {
  const t = useTranslation();

  return (
    <MyModal
      title={t["View API Token"]}
      subtitle={t["View API Token description"]}
      open={true}
      setOpen={onClose}
      variant="light"
    >
      <Stack spacing={2.5}>
        <DetailField label={t["Name"]} value={token.name} />
        <DetailField
          label={t["Token"]}
          value={<TokenShow token={token.token} light />}
        />
        <DetailField
          label={t["Expiry"]}
          value={token.expiry ? dateFormat(token.expiry) : t["Never"] || "Never"}
        />
      </Stack>

      <Box display="flex" justifyContent="flex-end" mt={3}>
        <Button
          type="button"
          variant="outlined"
          onClick={onClose}
          sx={{
            minWidth: 120,
            height: 44,
            borderRadius: `${COLORS.radius.md}px`,
            borderColor: COLORS.surface.border,
            color: COLORS.surface.primaryText,
            fontWeight: 500,
            textTransform: "none"
          }}
        >
          {t["Close"]}
        </Button>
      </Box>
    </MyModal>
  );
}
